<a class="position"  title="Add to Favourites" (click)="editFav()" *ngxPermissionsOnly="['Student']">
    <i class="fa fa-heart" *ngIf="fav" aria-hidden="true"></i>
    <i class="fa-regular fa-heart" *ngIf="!fav" aria-hidden="true"></i>
</a>

<a class="position-2" [ngClass]="{'position-2': !IsAdmin, position: IsAdmin}" title="Copy Link" (click)="open(mymodal)">
    <i class="fa fa-share-alt"></i>
</a>

<ng-template #mymodal let-modal>
    <div class="modal-body row share-container">
        <div class="col-12">
            <button type="button" class="close" (click)="modal.dismiss()">
                <span>×</span>
            </button>
        </div>
        <div class="col-12 text-center">
            <p><i class="fa fa-link"></i></p>
        </div>
        <div class="col-12 text-center mt-4">
            <h5 class="font-weight-bold ">{{ courseTitle }}</h5>
        </div>
        <div class="col-12 mb-3 mt-2">
            <input type="text" class="form-control text-left" [value]="courseLink" [readonly]="true" #link>
        </div>

        <div class="col-12 text-center">
            <button type="button" class="btn" [ngClass]="{'btn-muted': copied, 'btn-success': !copied}" (click)="copyLink(link)" >
                <i *ngIf="copied"class="fa fa-check"></i>  {{'course.copyUrl' |translate}} </button>
        </div>
    </div>
</ng-template>
